package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_05_30_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes battling the Drow adventurers deep under the Gideon forest.")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Falorn is unconscious.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Many on both sides are badly damaged.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Bigglesworth and Caper are Tyrannosaurus Rexes.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Vargas and Tressa are trapped in Dirk’s Whirlwind.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Elrovir finishes off Ramadeth. Parvir casts Hideous Laughter on Annette.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper bites down hard on Tressa, trapping her inside her massive jaws. Tressa tries to heal herself but Tuesday counterspells her. Vargas breaks out of Dirk’s whirlwind and is launched southwest into the cave wall. Caper chases Vargas and tailswipes him to death. Hotari yells, “Brother,” abandons her cover, and runs across the open room toward his lifeless body.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Bigglesworth bites Delia, grappling her, and runs to Ramadeth’s body and tailswipes it. Delia is able to pry herself loose but suffers a rough landing, falling from the T-Rex’s jaw.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Hotari reaches Vargas and begs for mercy. Tuesday demands that the Drow leave their weapons and shinies behind and teleport away.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn regains consciousness and the heroes inspect the loot left by the Drow.")
    }
    org.jetbrains.compose.web.dom.Table {
        org.jetbrains.compose.web.dom.Thead {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Th(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Source")
                }
                org.jetbrains.compose.web.dom.Th(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Item")
                }
                org.jetbrains.compose.web.dom.Th(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Who")
                }
            }
        }
        org.jetbrains.compose.web.dom.Tbody {
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Tressa")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/5389-holy-avenger") {
                        org.jetbrains.compose.web.dom.Text("Holy Avenger")
                    }
                    org.jetbrains.compose.web.dom.Text(" Long Sword")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Annette")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Tressa")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/5399-vicious-weapon") {
                        org.jetbrains.compose.web.dom.Text("Vicious")
                    }
                    org.jetbrains.compose.web.dom.Text(" Morning Star +2")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Bag of Holding")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Hotari")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/5399-vicious-weapon") {
                        org.jetbrains.compose.web.dom.Text("Vicious")
                    }
                    org.jetbrains.compose.web.dom.Text(" Long Bow +3")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Caper")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Hotari")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/5394-nine-lives-stealer") {
                        org.jetbrains.compose.web.dom.Text("9 Lives Stealer")
                    }
                    org.jetbrains.compose.web.dom.Text(" Short Sword (6 charges remaining)")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Bag of Holding")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Vargas")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Razorwrath, sentient ")
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/5397-vorpal-sword") {
                        org.jetbrains.compose.web.dom.Text("Vorpal")
                    }
                    org.jetbrains.compose.web.dom.Text(" Longsword +4")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Bigglesworth")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Vargas")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Longsword +3")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("~~Bag of Holding~~ Goram")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Ramadeth")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Morning Star +2")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("~~Bag of Holding~~ Goram")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Parvir")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/5399-vicious-weapon") {
                        org.jetbrains.compose.web.dom.Text("Vicious")
                    }
                    org.jetbrains.compose.web.dom.Text(" Dagger")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Tuesday")
                }
            }
            org.jetbrains.compose.web.dom.Tr {
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Delia")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    com.varabyte.kobweb.silk.components.navigation.Link("https://www.dndbeyond.com/magic-items/5390-sword-of-life-stealing") {
                        org.jetbrains.compose.web.dom.Text("Life Stealing")
                    }
                    org.jetbrains.compose.web.dom.Text(" Greatsword")
                }
                org.jetbrains.compose.web.dom.Td(attrs = { style {property("text-align", "left")} }) {
                    org.jetbrains.compose.web.dom.Text("Bag of Holding")
                }
            }
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("6 money pouches totaling 645 platinum pieces")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn notices pools of black ichor in the corners of the room and suspects that demons were slain here in the last 3-7 days. Dirk recognizes the altar in the north of the room as Venelar, evil god, prince of death, and patron of assassins. North of the altar, the heroes see the shard of the Shield of Concar locked inside a field of force. They decide to rest for the night before attempting to free the shard from the force prison. Dirk reluctantly casts Tiny Hut as he has exhausted his high-level spell slots he would normally use for Magnificent Mansion.")
    }
}
